
































































































































































































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Offer } from '@/data/models/offer.model';
import { Search, SortDirection } from '@/data/models/search.model';
import store, { State } from '@/store';
import AddRiscossione from './riscossione/AddRiscossione.vue';
import { OfferService } from '@/data/services/offer.service';
import { download } from '@/data/utils/helper';
import { Page } from '@/data/models/page.model';
import { Contatto } from '@/data/models/contatto.model';
import EditContatto from '../contatti/contatto/EditContatto.vue';
import { BModalComponent } from 'buefy/types/components';

@Component
export default class RiscossioneList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: false }) selectable!: boolean;
	@Prop({ default: false }) deliveryActions!: boolean;
	@Prop({ default: () => [] }) selected!: Offer[];
	@Prop({ default: false }) incassatoAction!: boolean;
	
	@Inject('CrudService') crudService!: CrudService<Offer>;
	@Inject('CrudService') contactService!: CrudService<Contatto>;
	@Inject('OfferService') offerService!: OfferService;

	rows: Offer[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('offer join contact on offer.contactid = contact.id left join user as u1 on offer.operatorid = u1.id left join user as u2 on offer.deliveryid = u2.id');
	checkedRows: Offer[] = [];

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
		this.advancedSearch.page = new Page(100);
	}

	loadData() {
		this.checkedRows = [];

		const datareq = this.crudService.searchEntities(
			Offer,
			'offer',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Offer,
			'offer',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.$emit('dataload', this.rows.length);
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadData();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadData();
	}

	onCheck(checked: Offer[]) {
		this.$emit('update:selected', checked);
	}

	onDeliveryAction(offer: Offer, action: string) {
		this.$emit('deliveryaction', { offer, action });
	}

	printBusta(row: Offer) {
		const loading = this.$buefy.loading.open({});
		this.offerService.printBusta(row.id).then(response => {
			download(response, `ricevuta_${row.id}.pdf`);
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

	onEdit(offer: Offer) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: AddRiscossione,
			hasModalCard: true,
			canCancel: false,
			props: {
				offerId: offer.id
			},
			events: {
				submit: () => {
					this.loadData();
					modal.close();
				},
			},
		});
	}

	onDelete(offer: Offer) {
		this.$emit('delete', offer);
	}

	openModal(contact: Contatto) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditContatto,
			props: {
				contatto: contact,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Contatto) => {
					this.saveContatto(value, modal);
				},
			},
		});
	}

	saveContatto(value: Contatto, modal: BModalComponent) {
		value.hqid = this.state.headquarter!.id;
		this.contactService
			.createEntity(Contatto, 'contact', value)
			.then(() => {
				this.loadData();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}
}
